import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

function HeaderNavLink(props) {
  return (
    <Link to={props.to} className={`nav-btn ${props.className}`} onClick={props.hideMenu}>
      {props.children}
    </Link>
  );
}

HeaderNavLink.propTypes = {
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
  hideMenu: PropTypes.func,
};

export default HeaderNavLink;
